<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

// Реактивная переменная для отслеживания видимости пароля
const showPassword = ref(false);
const showPassword2 = ref(false);

// Реактивные переменные для данных формы
const firstName = ref("");
const lastName = ref("");
const patronymic = ref("");
const email = ref("");
const password = ref("");
const passwordConfirm = ref("");

// Вычисляем свойство для валидации формы (реактивно следит за email и password)

const router = useRouter();

const isFormValid = computed(() => {
  // prettier-ignore
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // prettier-ignore
  return emailPattern.test(email.value) 
    && firstName.value.trim() !== "" 
    && lastName.value.trim() !== "" 
    && password.value.length >= 6 
    && passwordConfirm.value.length >= 6
    && password.value === passwordConfirm.value;
});

const handleRegisterSubmit = async () => {
  // Валидация: проверяем, что пароли совпадают
  if (password.value !== passwordConfirm.value) {
    alert("ОШИБКА: Пароли не совпадают!");
    return; // Останавливаем отправку
  }

  const registerData = {
    firstName: firstName.value,
    lastName: lastName.value,
    surName: patronymic.value, // На бэкенде это поле называется surName
    email: email.value,
    password: password.value,
  };
  console.log("Данные для бэкенда (Регистрация):", registerData);
  // Отправляем данные на твой Node.js бэкенд
  try {
    const response = await fetch("/api/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(registerData),
    });
    const data = await response.json();

    if (response.ok) {
      alert("Успешная регистрация! Теперь войдите в аккаунт.");
      // Перекидываем на страницу логина
      router.push("/login");
    } else {
      alert("Ошибка: " + data.error);
    }
  } catch (error) {
    console.error("Ошибка сети:", error);
  }
};
</script>

<template>
  <div class="flex h-svh w-full bg-whitebglog">
    <!-- prettier-ignore  -->
    <div class="flex mx-auto max-w-[1685px] mx-full
    w-[480px] h-full items-center justify-center">
      <!-- prettier-ignore  -->
      <div class="flex bg-white max-h-[970px] rounded-3xl items-center 
      justify-center p-6 sm:p-10">
        <form class="flex flex-col gap-5 w-full max-w-sm" @submit.prevent="handleRegisterSubmit">

          <div class="flex justify-center">
            <img src="../../public/svg/HandBox_icon.svg" class="w-[64px] h-[64px]" alt="Icon" >
          </div>
          
          <h2 class="text-3xl font-bold text-center mb-4 text-black">Регистрация</h2>
          
          <input
            type="text"
            v-model="firstName"
            placeholder="Имя"
            class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
            focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all"
            required
          >

          <input
            type="text"
            v-model="lastName"
            placeholder="Фамилия"
            class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
            focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all"
            required
          >

          <input
            type="text"
            v-model="patronymic"
            placeholder="Отчество (если есть)"
            class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
            focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all"
          >

          <input
            type="email"
            v-model="email"
            placeholder="Электронная почта"
            class="text-black bg-white p-4 rounded-xl border border-gray-300 w-full
            focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500
            transistion-all" required
          />

          <div class="relative w-full">
    
            <input 
              :type="showPassword ? 'text' : 'password'" 
              v-model="password"
              placeholder="Пароль" 
              class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
              focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all"
              required
            >
    
            <button 
              type="button" 
              @click="showPassword = !showPassword"
              class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center 
              mr-4 text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              <span class="text-lg leading-none cursor-pointer">{{ showPassword ? '👁️' : '👁️‍🗨️' }}</span>
            </button>
          </div>

            <div class="relative w-full">
    
            <input 
              :type="showPassword2 ? 'text' : 'password'" 
              v-model="passwordConfirm"
              placeholder="Повторите пароль" 
              class="w-full p-4 text-gray-700 bg-white border border-gray-300 rounded-xl
              focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500 transition-all"
              required
            >
    
            <button 
              type="button"
              @click="showPassword2 = !showPassword2" 
              class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center 
              mr-4 text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              <span class="text-lg leading-none cursor-pointer">{{ showPassword2 ? '👁️' : '👁️‍🗨️' }}</span>
            </button>
          </div>

          <p class="text-sm">
            Нажимая на кнопку вы соглашаетесь с правилами пользования платформой
          </p>

          <button
            type="submit" 
            :disabled="!isFormValid"
            :class="[
              'font-normal p-4 rounded-xl w-full transition-colors mt-2',
              isFormValid 
                ? 'bg-black text-white hover:bg-gray-800 cursor-pointer' 
                : 'bg-[#D9D9D9] text-[#888888] cursor-not-allowed'
            ]"
          >
            Создать профиль
          </button>

        </form>
      </div>
    </div>
  </div>
</template>
